import { createSlice } from "@reduxjs/toolkit";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import PatolojiNumuneKabulAramaKriterleri from "./PatolojiNumuneKabulAramaKriterleri";
import VwPatKabulehazirnumuneDTO from "src/models/PatolojiModul/VwPatKabulehazirnumuneDTO";
import VwPatolojiNumuneKabulDTO from "src/models/PatolojiModul/VwPatolojiNumuneKabulDTO";
import { GridFilterModel } from "@mui/x-data-grid-premium";

interface IPatolojiNumuneKabul {
    searchHandler?: boolean;
    aramaKriterleri?: PatolojiNumuneKabulAramaKriterleri;
    activeRow?: VwPatolojiNumuneKabulDTO;
    detayOpen?: boolean;

    bekleyenTaleplerOpen?: boolean;
    bekleyenTalepAramaKriterleri?: PatolojiNumuneKabulAramaKriterleri;
    bekleyenTalepSearchHandler: boolean;
    bekleyenTaleplerGridFilterModel: GridFilterModel;
    talepId: Array<number>;
    onayActiveRow: Array<VwPatKabulehazirnumuneDTO>;

    iptalOpen: boolean;

    onaySonucOpen?: boolean;
    onaySonucRaporIds?: string;
    onaySonucNavigate?: string;
};

export const PatolojiNumuneKabulSlice = createSlice<IPatolojiNumuneKabul, MapReducerPayloads<IPatolojiNumuneKabul, {
    setSearchHandler?: boolean;
    setAramaKriterleri?: PatolojiNumuneKabulAramaKriterleri;
    setActiveRow?: VwPatolojiNumuneKabulDTO;
    setDetayOpen?: boolean;

    setBekleyenTaleplerOpen?: boolean;
    setBekleyenTalepAramaKriterleri?: PatolojiNumuneKabulAramaKriterleri;
    setBekleyenTalepSearchHandler: boolean;
    setBekleyenTaleplerGridFilterModel: GridFilterModel;
    setTalepId: Array<number>;
    setOnayActiveRow: Array<VwPatKabulehazirnumuneDTO>;

    setIptalOpen: boolean;

    setOnaySonucOpen?: boolean;
    setOnaySonucRaporIds?: string;
    setOnaySonucNavigate?: string;
}>>({
    name: "patolojiNumuneKabul",
    initialState: {
        searchHandler: true,
        aramaKriterleri: new PatolojiNumuneKabulAramaKriterleri(),
        activeRow: new VwPatolojiNumuneKabulDTO(),
        detayOpen: false,

        bekleyenTaleplerOpen: false,
        bekleyenTalepAramaKriterleri: new PatolojiNumuneKabulAramaKriterleri(),
        bekleyenTalepSearchHandler: true,
        bekleyenTaleplerGridFilterModel: { items: [] },
        talepId: null,
        onayActiveRow: new Array<VwPatKabulehazirnumuneDTO>(),

        iptalOpen: false,

        onaySonucOpen: false,
        onaySonucRaporIds: "",
        onaySonucNavigate: "",
    },
    reducers: {
        //Arama kriterlerini doldurduktan sonra api ye gidip veriyi çektiği state
        setSearchHandler: (state, action) => {
            state.searchHandler = action.payload
        },
        //Arama kriterlerinin tutulduğu state
        setAramaKriterleri: (state, action) => {
            state.aramaKriterleri = action.payload
        },
        //İlgili row detayının bilgilerinin tutulduğu state
        setActiveRow: (state, action) => {
            state.activeRow = action.payload
        },
        //İlgili numune kaydının detay bilgilerinin bulunduğu dialog penceresini açar
        setDetayOpen: (state, action) => {
            state.detayOpen = action.payload
        },
        //Numune kabulde bekleyen talepler butonu ile dialog ekranını açar
        setBekleyenTaleplerOpen: (state, action) => {
            state.bekleyenTaleplerOpen = action.payload
        },
        //Bekleyen talepler arama kriterleri
        setBekleyenTalepAramaKriterleri: (state, action) => {
            state.bekleyenTalepAramaKriterleri = action.payload
        },
        //Bekleyen talepler arama kriterlerini doldurduktan sonra api ye gidip veriyi çektiği state
        setBekleyenTalepSearchHandler: (state, action) => {
            state.bekleyenTalepSearchHandler = action.payload
        },
        //Bekleyen talepler grid arama kriterleri doldurulduktan sonra kullanılan state
        setBekleyenTaleplerGridFilterModel: (state, action) => {
            state.bekleyenTaleplerGridFilterModel = action.payload
        },
        //Bekleyen talepler ekranı datagrid checkbox ile işaretlenen kayıtların idleri
        setTalepId: (state, action) => {
            state.talepId = action.payload
        },
        //Bekleyen taleplerde listedeki activerow'unu set eder.
        setOnayActiveRow: (state, action) => {
            state.onayActiveRow = action.payload
        },
        //Numune kabulde iptal dialog
        setIptalOpen: (state, action) => {
            state.iptalOpen = action.payload
        },

        //Numune onayda sonuç gösterme dialog
        setOnaySonucOpen: (state, action) => {
            state.onaySonucOpen = action.payload
        },
        //Numune onayda sonuç dialog ekranında virgüllü şekilde dönen hasta rapor idlerinin set edildiği state
        setOnaySonucRaporIds: (state, action) => {
            state.onaySonucRaporIds = action.payload
        },
        setOnaySonucNavigate: (state, action) => {
            state.onaySonucNavigate = action.payload
        },
    }
});